export const defaultInspection = () => ({
  inspectionPoints: {}
});
